export class HelperUtil {
    public static showLogs(): boolean {
        return (window as any)['easyLinkLogs'] === true
    }
}
